import { connect } from "react-redux";
import { connect as formikConnect } from "formik";
import includes from "lodash/includes";
import { ownerPortfoliosWithAssetsSelector } from "selectors/portfolio";

import PortfolioAsset from "./PortfolioAsset";

const mapStateToProps = (
  state,
  {
    formik: {
      values: { portfolio },
    },
  }
) => ({
  portfolio,
  portfolios: ownerPortfoliosWithAssetsSelector(state),
  assets: portfolio
    ? state.assetNames.filter(
        (a) => a.portfolio.id === portfolio.id && includes(["public", "invite"], a.status)
      )
    : [],
});

export default formikConnect(connect(mapStateToProps)(PortfolioAsset));
